// @ts-nocheck
import { useState } from 'react';
import { toast } from 'sonner';
import { Info, Pencil, Plus, Trash2, Zap } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import AddFunctionDialog from './AddFunctionDialog';
import CustomApiFunctionDialog from './CustomApiFunctionDialog';
import HeadingInfo from './HeadingInfo';
import { AI_AGENT_FIELD_LIMITS } from '@/utilities/constant';

const { API_MAX_ITEMS } = AI_AGENT_FIELD_LIMITS;

export default function FunctionsCard({ value, onChange }: any) {
  const functions = value ?? [];
  const [addOpen, setAddOpen] = useState(false);
  const [formOpen, setFormOpen] = useState(false);
  const [editing, setEditing] = useState<any>(null);

  const openCreate = () => {
    if (functions.length >= API_MAX_ITEMS) {
      toast.error(`You can add up to ${API_MAX_ITEMS} APIs`);
      return;
    }
    setEditing(null);
    setFormOpen(true);
  };

  const openEdit = (fn: any) => {
    setEditing(fn);
    setFormOpen(true);
  };

  const handleSave = (fn: any) => {
    const exists = functions.some((f: any) => f.id === fn.id);
    onChange?.(exists ? functions.map((f: any) => (f.id === fn.id ? fn : f)) : [...functions, fn]);
    toast.success(editing ? 'Function updated' : 'Function added');
  };

  const handleDelete = (id: string) => {
    onChange?.(functions.filter((f: any) => f.id !== id));
  };

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0">
        <CardTitle className="flex items-center gap-1.5 text-base">
          Functions
          <HeadingInfo text="External APIs the AI can call during the conversation, e.g. to look up an order or create a ticket." />
          <span className="text-xs font-normal text-muted-foreground">
            ({functions.length}/{API_MAX_ITEMS})
          </span>
        </CardTitle>
        <Button
          size="sm"
          variant="outline"
          onClick={() => setAddOpen(true)}
          disabled={functions.length >= API_MAX_ITEMS}
        >
          <Plus className="h-4 w-4" />
          Functions
        </Button>
      </CardHeader>
      <CardContent>
        {functions.length === 0 ? (
          <p className="py-6 text-center text-sm text-muted-foreground">No functions added yet.</p>
        ) : (
          <div className="space-y-2">
            {functions.map((fn) => (
              <div
                key={fn.id}
                className="flex items-center justify-between rounded-md border px-3 py-2"
              >
                <span className="flex items-center gap-2 text-sm font-medium text-foreground">
                  <Zap className="h-4 w-4 text-orange-500" />
                  {fn.name}
                </span>
                <span className="flex items-center gap-1">
                  <Button
                    variant="ghost"
                    size="icon"
                    className="h-8 w-8 text-primary hover:text-primary"
                    onClick={() => openEdit(fn)}
                  >
                    <Pencil className="h-4 w-4" />
                  </Button>
                  <Button
                    variant="ghost"
                    size="icon"
                    className="h-8 w-8 text-destructive hover:text-destructive"
                    onClick={() => handleDelete(fn.id)}
                  >
                    <Trash2 className="h-4 w-4" />
                  </Button>
                </span>
              </div>
            ))}
          </div>
        )}
      </CardContent>

      <AddFunctionDialog open={addOpen} onOpenChange={setAddOpen} onCreateCustomApi={openCreate} />
      <CustomApiFunctionDialog
        open={formOpen}
        onOpenChange={setFormOpen}
        initial={editing}
        onSave={handleSave}
      />
    </Card>
  );
}